import * as React from 'react';

export function SvgSpeedXFast(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="m18 13c0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6 0 1.6791.6884 3.1956 1.80092 4.2858.39446.3865.40088 1.0196.01434 1.4141-.38655.3945-1.01968.4009-1.41414.0143-1.48059-1.4508-2.40112-3.4759-2.40112-5.7142 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 2.2383-.9205 4.2634-2.4011 5.7142-.3945.3866-1.0276.3802-1.4142-.0143-.3865-.3945-.3801-1.0276.0144-1.4141 1.1125-1.0902 1.8009-2.6067 1.8009-4.2858zm-1.8991-1.2548c.1099-.0841.265-.0738.3629.0241.1027.1027.1082.2676.0125.377l-4.143 4.7348c-.3445.3938-.9503.414-1.3203.044-.3868-.3868-.3444-1.0258.0901-1.3582z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
